import RequiredAttachments from "./RequiredAttachments";

export default RequiredAttachments;
